import React from 'react'
import RoyalLongsword from 'src/images/weapons/royal_longsword.png'
import RoyalGreatSword from 'src/images/weapons/royal_greatsword.png'
import RoyalSpear from 'src/images/weapons/royal_spear.png'
import RoyalBow from 'src/images/weapons/royal_bow.png'
import RoyalGrimoire from 'src/images/weapons/royal_grimoire.png'
import BlackcliffLongsword from 'src/images/weapons/blackcliff_longsword.png'
import BlackcliffSlasher from 'src/images/weapons/blackcliff_slasher.png'
import BlackcliffPole from 'src/images/weapons/blackcliff_pole.png'
import BlackcliffWarbow from 'src/images/weapons/blackcliff_warbow.png'
import BlackcliffAgate from 'src/images/weapons/blackcliff_agate.png'

const iconSize = 48

export const RoyalSeries = {
  name: 'Royal series',
  weapons: [
    <img width={iconSize} height={iconSize} src={RoyalLongsword} alt="Royal longsword" />,
    <img width={iconSize} height={iconSize} src={RoyalGreatSword} alt="Royal greatsword" />,
    <img width={iconSize} height={iconSize} src={RoyalSpear} alt="Royal spear" />,
    <img width={iconSize} height={iconSize} src={RoyalBow} alt="Royal bow" />,
    <img width={iconSize} height={iconSize} src={RoyalGrimoire} alt="Royal grimoire" />,
  ]
}

export const BlackcliffSeries = {
  name: 'Blackcliff Series',
  weapons: [
    <img width={iconSize} height={iconSize} src={BlackcliffLongsword} alt="Blackcliff longsword" />,
    <img width={iconSize} height={iconSize} src={BlackcliffSlasher} alt="Blackcliff slasher" />,
    <img width={iconSize} height={iconSize} src={BlackcliffPole} alt="Blackcliff pole" />,
    <img width={iconSize} height={iconSize} src={BlackcliffWarbow} alt="Blackcliff warbow" />,
    <img width={iconSize} height={iconSize} src={BlackcliffAgate} alt="Blackcliff agate" />,
  ]
}
